import { CustomTrace, RechartData, RechartDataObject } from 'src/Libs/chart-kit/shared/utils/chartModel'

const getCustomSum = (customTrace: CustomTrace, dataPoint: RechartDataObject): number | undefined =>
  customTrace.sumKeys?.reduce((prev, curr) => {
    if (curr.operand === 'add') {
      return prev + (dataPoint[curr.key] as number)
    }
    return prev - (dataPoint[curr.key] as number)
  }, 0)

export const addCustomSumsToData = (data: RechartData, customSums: CustomTrace[] | undefined): void => {
  if (!data.data || !customSums?.length || !data.sums) return

  for (const customSum of customSums) {
    for (const dataPoint of data.data) {
      const sum = getCustomSum(customSum, dataPoint)
      if (sum !== undefined && !Number.isNaN(sum)) {
        dataPoint[customSum.alternateKey!] = sum
      }
    }
  }
}
